import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { DURATION_2, DURATION_3, EASING_FUNCTION_1, EASING_FUNCTION_2, FADE_IN, FADE_OUT, SLIDE_DOWN_IN20, SLIDE_DOWN_OUT20, SLIDE_LEFT_IN20, SLIDE_RIGHT_IN20, SLIDE_UP_IN20, SLIDE_UP_OUT20, TRANSITION_ROW_DISAPPEARANCE } from '../../utils';
import { AnimationDirection } from '../Calendar/Calendar.types';
import { weekCornersClassNames } from './useWeekCornerStyles.styles';
/**
 * @internal
 */
export const calendarDayGridClassNames = {
  wrapper: 'fui-CalendarDayGrid__wrapper',
  table: 'fui-CalendarDayGrid__table',
  dayCell: 'fui-CalendarDayGrid__dayCell',
  daySelected: 'fui-CalendarDayGrid__daySelected',
  weekRow: 'fui-CalendarDayGrid__weekRow',
  weekDayLabelCell: 'fui-CalendarDayGrid__weekDayLabelCell',
  weekNumberCell: 'fui-CalendarDayGrid__weekNumberCell',
  dayOutsideBounds: 'fui-CalendarDayGrid__dayOutsideBounds',
  dayOutsideNavigatedMonth: 'fui-CalendarDayGrid__dayOutsideNavigatedMonth',
  dayButton: 'fui-CalendarDayGrid__dayButton',
  dayIsToday: 'fui-CalendarDayGrid__dayIsToday',
  firstTransitionWeek: 'fui-CalendarDayGrid__firstTransitionWeek',
  lastTransitionWeek: 'fui-CalendarDayGrid__lastTransitionWeek',
  dayMarker: 'fui-CalendarDayGrid__dayMarker'
};
/**
 * @internal
 */
export const extraCalendarDayGridClassNames = {
  hoverStyle: 'fui-CalendarDayGrid__hoverStyle',
  pressedStyle: 'fui-CalendarDayGrid__pressedStyle'
};
const useWrapperStyles = /*#__PURE__*/__styles({
  base: {
    Byoj8tv: "f1fow5ox"
  }
}, {
  d: [".f1fow5ox{padding-bottom:10px;}"]
});
const useTableStyles = /*#__PURE__*/__styles({
  base: {
    po53p8: "fgkb47j",
    Bxjg3zr: "f16vktn6",
    Be2twd7: "fjoy568",
    B6of3ja: "fvjh0tl",
    Byoj8tv: "f1fow5ox",
    qhf8xq: "f10pi13n",
    B73mfa3: "f14m3nip",
    fsow6f: "f17mccla",
    a9b677: "f4m2ahc"
  },
  showWeekNumbers: {
    a9b677: "fl524qk"
  }
}, {
  d: [".fgkb47j{border-collapse:collapse;}", ".f16vktn6{border-spacing:0;}", ".fjoy568{font-size:inherit;}", ".fvjh0tl{margin-top:4px;}", ".f1fow5ox{padding-bottom:10px;}", ".f10pi13n{position:relative;}", ".f14m3nip{table-layout:fixed;}", ".f17mccla{text-align:center;}", ".f4m2ahc{width:196px;}", ".fl524qk{width:226px;}"]
});
const useDayCellStyles = /*#__PURE__*/__styles({
  base: {
    sj55zd: "f19n0e5",
    Bceei9c: "f1k6fduh",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bqenvij: "fxldao9",
    Bg96gwp: "f336tjw",
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f11qmguv", "f1tyq0we"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"],
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    qhf8xq: "f10pi13n",
    a9b677: "f1w9dchk",
    Bsw6fvg: "f8pusc0",
    Bbusuzp: "fqgauei",
    cvlxnx: "fp6dsbd",
    Bweudez: "f4xgodq",
    hzfqlu: "fehmveg",
    Bb91d7d: "ff78tpz",
    dua3dm: "f128nre3",
    z1p9vi: "f1elgve3",
    Bsnevi5: "f15e7s3w",
    xnb59o: "fts5qqo",
    Bj67fi1: "f1lhgsq9",
    B2gfgcj: "fdbuq6n",
    B6cqqer: "f16j2ub3",
    fpurfy: "f5hk6jp",
    Fioj4w: ["f1d258es", "f1llk4aj"],
    Bq9yiu4: "ftezgwa",
    cpbo2x: ["f1llk4aj", "f1d258es"],
    Bq268z6: "f1iohfpm"
  }
}, {
  d: [".f19n0e5{color:var(--colorNeutralForeground1);}", ".f1k6fduh{cursor:pointer;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fxldao9{height:28px;}", ".f336tjw{line-height:28px;}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".f10pi13n{position:relative;}", ".f1w9dchk{width:28px;}", ".fp6dsbd.fui-CalendarDayGrid__hoverStyle{color:var(--colorNeutralForeground1Static);}", ".f4xgodq.fui-CalendarDayGrid__hoverStyle{background-color:var(--colorBrandBackgroundInvertedHover);}", ".f1lhgsq9.fui-CalendarDayGrid__pressedStyle{color:var(--colorNeutralForeground1Static);}", ".fdbuq6n.fui-CalendarDayGrid__pressedStyle{background-color:var(--colorBrandBackgroundInvertedPressed);}"],
  m: [["@media (forced-colors: active){.f8pusc0{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fqgauei{color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fehmveg.fui-CalendarDayGrid__hoverStyle{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.ff78tpz.fui-CalendarDayGrid__hoverStyle{color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f128nre3.fui-CalendarDayGrid__hoverStyle{outline-width:1px;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1elgve3.fui-CalendarDayGrid__hoverStyle{outline-style:solid;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f15e7s3w.fui-CalendarDayGrid__hoverStyle{outline-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fts5qqo.fui-CalendarDayGrid__hoverStyle{z-index:3;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f16j2ub3.fui-CalendarDayGrid__pressedStyle{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f5hk6jp.fui-CalendarDayGrid__pressedStyle{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1d258es.fui-CalendarDayGrid__pressedStyle{border-right-color:Highlight;}.f1llk4aj.fui-CalendarDayGrid__pressedStyle{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.ftezgwa.fui-CalendarDayGrid__pressedStyle{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1iohfpm.fui-CalendarDayGrid__pressedStyle{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useDaySelectedStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1vevd59",
    sj55zd: "ff5vbop",
    Bsw6fvg: "f1rirnrt",
    Bjwas2f: "f132fbg1",
    Bn1d65q: ["f1ene5x0", "fzbc999"],
    Bxeuatn: "f6jgcol",
    n51gp8: ["fzbc999", "f1ene5x0"],
    Bbusuzp: "f1lkg8j3",
    ycbfsm: "fkc42ay",
    a3nq4f: "f1chdfq9",
    Bnf3alp: "fq0dbue",
    H2c3sd: "f3pe0v7",
    qu8ld: "f3t0uu2",
    Bg4iunc: "f1cikclm"
  }
}, {
  d: [".f1vevd59{background-color:var(--colorBrandBackgroundInvertedSelected);}", ".ff5vbop{color:var(--colorNeutralForeground1Static);}"],
  m: [["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f132fbg1{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ene5x0{border-right-color:Highlight;}.fzbc999{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f6jgcol{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f3pe0v7:hover,.f3pe0v7.fui-CalendarDayGrid__hoverStyle,.f3pe0v7.fui-CalendarDayGrid__pressedStyle{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f3t0uu2:hover,.f3t0uu2.fui-CalendarDayGrid__hoverStyle,.f3t0uu2.fui-CalendarDayGrid__pressedStyle{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1cikclm>.fui-CalendarDayGrid__dayMarker{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".f1chdfq9:hover,.f1chdfq9.fui-CalendarDayGrid__hoverStyle,.f1chdfq9.fui-CalendarDayGrid__pressedStyle{color:var(--colorNeutralForeground1Static);}", ".fq0dbue:hover,.fq0dbue.fui-CalendarDayGrid__hoverStyle,.fq0dbue.fui-CalendarDayGrid__pressedStyle{background-color:var(--colorBrandBackgroundInvertedSelected);}"]
});
const useWeekRowStyles = /*#__PURE__*/__styles({
  base: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Ezkn3b: "f1ee2ue"
  },
  horizontalBackward: {
    Bv12yb3: ["f1o9w3l8", "f1kwjajc"]
  },
  horizontalForward: {
    Bv12yb3: ["f1kwjajc", "f1o9w3l8"]
  },
  verticalBackward: {
    Bv12yb3: "fgl3yn7"
  },
  verticalForward: {
    Bv12yb3: "faiu5ye"
  }
}, {
  d: [".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}", ".f1o9w3l8{animation-name:f5j8bii,f2lgmc3;}", ".f1kwjajc{animation-name:f5j8bii,fpktcv7;}", ".fgl3yn7{animation-name:f5j8bii,f3bv9km;}", ".faiu5ye{animation-name:f5j8bii,funtx0y;}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}", "@keyframes f2lgmc3{from{pointer-events:none;transform:translate3d(-20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes fpktcv7{from{pointer-events:none;transform:translate3d(20px, 0, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes f3bv9km{from{pointer-events:none;transform:translate3d(0, -20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}", "@keyframes funtx0y{from{pointer-events:none;transform:translate3d(0, 20px, 0);}to{pointer-events:auto;transform:translate3d(0, 0, 0);}}"]
});
const useWeekDayLabelCellStyles = /*#__PURE__*/__styles({
  base: {
    vin17d: "fhsqnsn",
    Bf5fcs: "fywypte",
    Bv12yb3: "f1h7u52p",
    Ezkn3b: "fjq4c94"
  }
}, {
  d: [".fhsqnsn{animation-duration:0.267s;}", ".fywypte{animation-fill-mode:both;}", ".f1h7u52p{animation-name:f5j8bii;}", ".fjq4c94{animation-timing-function:cubic-bezier(.1,.25,.75,.9);}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}"]
});
const useWeekNumberCellStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    g2u3we: "f68mrw8",
    h3c5rm: ["f7pw515", "fw35ms5"],
    B9xav0g: "frpde29",
    zhjwy3: ["fw35ms5", "f7pw515"],
    Bekrc4i: ["f1hqa2wf", "finvdd3"],
    vrafjx: ["fcdblym", "fjik90z"],
    B7ck84d: "f1ewtqcl",
    sj55zd: "fxc4j92",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bqenvij: "fxldao9",
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f11qmguv", "f1tyq0we"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"],
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    a9b677: "f1w9dchk"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f68mrw8{border-top-color:var(--colorNeutralStroke2);}", ".f7pw515{border-right-color:var(--colorNeutralStroke2);}", ".fw35ms5{border-left-color:var(--colorNeutralStroke2);}", ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".f1ewtqcl{box-sizing:border-box;}", ".fxc4j92{color:var(--colorNeutralForeground4);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fxldao9{height:28px;}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".f1w9dchk{width:28px;}"]
});
const useDayOutsideBoundsStyles = /*#__PURE__*/__styles({
  base: {
    x734em: "f1v4z6xg",
    B0ssf13: "f1u9q7oh",
    B8h8h5z: "f1a22lcc",
    Bbusuzp: "f1dcs8yz"
  }
}, {
  d: [".f1v4z6xg,.f1v4z6xg:disabled,.f1v4z6xg button,.f1v4z6xg.fui-CalendarDayGrid__hoverStyle,.f1v4z6xg.fui-CalendarDayGrid__pressedStyle{background-color:var(--colorTransparentBackground);}", ".f1u9q7oh,.f1u9q7oh:disabled,.f1u9q7oh button,.f1u9q7oh.fui-CalendarDayGrid__hoverStyle,.f1u9q7oh.fui-CalendarDayGrid__pressedStyle{color:var(--colorNeutralForegroundDisabled);}", ".f1a22lcc,.f1a22lcc:disabled,.f1a22lcc button,.f1a22lcc.fui-CalendarDayGrid__hoverStyle,.f1a22lcc.fui-CalendarDayGrid__pressedStyle{pointer-events:none;}"],
  m: [["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useDayOutsideNavigatedMonthStyles = /*#__PURE__*/__styles({
  lightenDaysOutsideNavigatedMonth: {
    sj55zd: "fxc4j92",
    Bhrd7zp: "figsok6",
    Bbusuzp: "f1dcs8yz"
  }
}, {
  d: [".fxc4j92{color:var(--colorNeutralForeground4);}", ".figsok6{font-weight:var(--fontWeightRegular);}"],
  m: [["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useDayButtonStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1c21dwh",
    Bbmb7ep: ["f2i1086", "f1rlsnju"],
    Beyfa6y: ["f1rlsnju", "f2i1086"],
    B7oj6ja: ["f1stktl2", "f1127022"],
    Btl43ni: ["f1127022", "f1stktl2"],
    icvyot: "f1ern45e",
    vrafjx: ["f1n71otn", "f1deefiw"],
    oivjwe: "f1h8hb77",
    wvpqe5: ["f1deefiw", "f1n71otn"],
    sj55zd: "f1ym3bx4",
    Bceei9c: "f1k6fduh",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "ff5ikls",
    Bqenvij: "frvgh55",
    Bg96gwp: "f8xlz6g",
    B68tc82: "f1mtd64y",
    Bmxbyg5: "f1y7q3j9",
    z8tnut: "f1g0x7ka",
    z189sj: ["fhxju0i", "f1cnd47f"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"],
    a9b677: "fq4mcun",
    Bx0yju7: "f10y451g",
    l98f4w: "f1dwpgx3"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f2i1086{border-bottom-right-radius:2px;}", ".f1rlsnju{border-bottom-left-radius:2px;}", ".f1stktl2{border-top-right-radius:2px;}", ".f1127022{border-top-left-radius:2px;}", ".f1ern45e{border-top-style:none;}", ".f1n71otn{border-right-style:none;}", ".f1deefiw{border-left-style:none;}", ".f1h8hb77{border-bottom-style:none;}", ".f1ym3bx4{color:inherit;}", ".f1k6fduh{cursor:pointer;}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".ff5ikls{font-weight:inherit;}", ".frvgh55{height:24px;}", ".f8xlz6g{line-height:24px;}", ".f1mtd64y{overflow-x:visible;}", ".f1y7q3j9{overflow-y:visible;}", ".f1g0x7ka{padding-top:0;}", ".fhxju0i{padding-right:0;}", ".f1cnd47f{padding-left:0;}", ".f1qch9an{padding-bottom:0;}", ".fq4mcun{width:24px;}", ".f10y451gspan{height:inherit;}", ".f1dwpgx3span{line-height:inherit;}"]
});
const useDayIsTodayStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "ffp7eso",
    Bbmb7ep: ["f1xbx3v5", "fh9p2o2"],
    Beyfa6y: ["fh9p2o2", "f1xbx3v5"],
    B7oj6ja: ["f18mldvw", "f3h6kr5"],
    Btl43ni: ["f3h6kr5", "f18mldvw"],
    sj55zd: "f1phragk",
    Bhrd7zp: "fl43uef",
    Bsw6fvg: "fg374yq",
    Bjwas2f: "fx4t0an",
    Bn1d65q: ["f1bd7qk0", "fk5vpic"],
    Bxeuatn: "fgxnpfp",
    n51gp8: ["fk5vpic", "f1bd7qk0"],
    Bbusuzp: "f1yig07e",
    ycbfsm: "fkc42ay",
    jxbfoe: "fj0lumn",
    Bg4iunc: "f1cikclm"
  }
}, {
  d: [".ffp7eso{background-color:var(--colorBrandBackground);}", ".f1xbx3v5{border-bottom-right-radius:100%;}", ".fh9p2o2{border-bottom-left-radius:100%;}", ".f18mldvw{border-top-right-radius:100%;}", ".f3h6kr5{border-top-left-radius:100%;}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fj0lumn>.fui-CalendarDayGrid__dayMarker{background-color:var(--colorNeutralForegroundOnBrand);}"],
  m: [["@media (forced-colors: active){.fg374yq{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fx4t0an{border-top-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1bd7qk0{border-right-color:WindowText;}.fk5vpic{border-left-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fgxnpfp{border-bottom-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1yig07e{color:Window;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1cikclm>.fui-CalendarDayGrid__dayMarker{background-color:Window;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useFirstTransitionWeekStyles = /*#__PURE__*/__styles({
  base: {
    Bqenvij: "fniina8",
    abs64n: "fk73vx1",
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    qhf8xq: "f1euv43f",
    a9b677: "f3tsq5r"
  },
  verticalForward: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Bv12yb3: "fb3mxun",
    Ezkn3b: "f1ee2ue"
  }
}, {
  d: [".fniina8{height:0;}", ".fk73vx1{opacity:0;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".f1euv43f{position:absolute;}", ".f3tsq5r{width:0;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".fb3mxun{animation-name:f199e34v,f76svrd,fhwv0sk;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}"],
  k: ["@keyframes f199e34v{from{opacity:1;}to{opacity:0;visibility:hidden;}}", "@keyframes f76svrd{from{transform:translate3d(0, 0, 0);}to{transform:translate3d(0, -20px, 0);}}", "@keyframes fhwv0sk{100%{height:0px;overflow-x:hidden;overflow-y:hidden;width:0px;}99.9%{height:28px;overflow-x:visible;overflow-y:visible;width:100%;}0%{height:28px;overflow-x:visible;overflow-y:visible;width:100%;}}"]
});
const useLastTransitionWeekStyles = /*#__PURE__*/__styles({
  base: {
    Bqenvij: "fniina8",
    B6of3ja: "flykjtj",
    abs64n: "fk73vx1",
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    qhf8xq: "f1euv43f",
    a9b677: "f3tsq5r"
  },
  verticalBackward: {
    vin17d: "f5f2jbu",
    Bf5fcs: "fywypte",
    Bv12yb3: "f1h56eac",
    Ezkn3b: "f1ee2ue"
  }
}, {
  d: [".fniina8{height:0;}", ".flykjtj{margin-top:-28px;}", ".fk73vx1{opacity:0;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".f1euv43f{position:absolute;}", ".f3tsq5r{width:0;}", ".f5f2jbu{animation-duration:0.367s;}", ".fywypte{animation-fill-mode:both;}", ".f1h56eac{animation-name:f199e34v,f18895iq,fhwv0sk;}", ".f1ee2ue{animation-timing-function:cubic-bezier(.1,.9,.2,1);}"],
  k: ["@keyframes f199e34v{from{opacity:1;}to{opacity:0;visibility:hidden;}}", "@keyframes f18895iq{from{transform:translate3d(0, 0, 0);}to{transform:translate3d(0, 20px, 0);}}", "@keyframes fhwv0sk{100%{height:0px;overflow-x:hidden;overflow-y:hidden;width:0px;}99.9%{height:28px;overflow-x:visible;overflow-y:visible;width:100%;}0%{height:28px;overflow-x:visible;overflow-y:visible;width:100%;}}"]
});
const useDayMarkerStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "fnggedw",
    Bbmb7ep: ["f1xbx3v5", "fh9p2o2"],
    Beyfa6y: ["fh9p2o2", "f1xbx3v5"],
    B7oj6ja: ["f18mldvw", "f3h6kr5"],
    Btl43ni: ["f3h6kr5", "f18mldvw"],
    B5kzvoi: "f1oq0udb",
    Bqenvij: "f6ywr7j",
    oyh7mz: ["f1vgc2s3", "f1e31b4d"],
    B6of3ja: "fgr6219",
    t21cq0: ["f1ujusj6", "fcgxt0o"],
    jrapky: "f10jk5vf",
    Frg6f3: ["fcgxt0o", "f1ujusj6"],
    qhf8xq: "f1euv43f",
    j35jbq: ["f1e31b4d", "f1vgc2s3"],
    a9b677: "faro0ui",
    Bsw6fvg: "fg374yq",
    ycbfsm: "fkc42ay"
  }
}, {
  d: [".fnggedw{background-color:var(--colorBrandForeground2);}", ".f1xbx3v5{border-bottom-right-radius:100%;}", ".fh9p2o2{border-bottom-left-radius:100%;}", ".f18mldvw{border-top-right-radius:100%;}", ".f3h6kr5{border-top-left-radius:100%;}", ".f1oq0udb{bottom:1px;}", ".f6ywr7j{height:4px;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", ".fgr6219{margin-top:auto;}", ".f1ujusj6{margin-right:auto;}", ".fcgxt0o{margin-left:auto;}", ".f10jk5vf{margin-bottom:auto;}", ".f1euv43f{position:absolute;}", ".faro0ui{width:4px;}"],
  m: [["@media (forced-colors: active){.fg374yq{background-color:WindowText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useCornerBorderAndRadiusStyles = /*#__PURE__*/__styles({
  corners: {
    Cy64m2: ["fgk2v8v", "flgychs"],
    Bnn43bw: ["fon8hnx", "f1dzb7s0"],
    feanbc: ["f5gufe6", "f6b3fnj"],
    B4268ip: ["fo35n0e", "f96pych"]
  }
}, {
  d: [".fgk2v8v.fui-CalendarDayGrid__topRightCornerDate{border-top-right-radius:2px;}", ".flgychs.fui-CalendarDayGrid__topRightCornerDate{border-top-left-radius:2px;}", ".fon8hnx.fui-CalendarDayGrid__topLeftCornerDate{border-top-left-radius:2px;}", ".f1dzb7s0.fui-CalendarDayGrid__topLeftCornerDate{border-top-right-radius:2px;}", ".f5gufe6.fui-CalendarDayGrid__bottomRightCornerDate{border-bottom-right-radius:2px;}", ".f6b3fnj.fui-CalendarDayGrid__bottomRightCornerDate{border-bottom-left-radius:2px;}", ".fo35n0e.fui-CalendarDayGrid__bottomLeftCornerDate{border-bottom-left-radius:2px;}", ".f96pych.fui-CalendarDayGrid__bottomLeftCornerDate{border-bottom-right-radius:2px;}"]
});
/**
 * @internal
 *
 * Apply styling to the CalendarDayGrid slots based on the state
 */
export const useCalendarDayGridStyles_unstable = props => {
  const wrapperStyles = useWrapperStyles();
  const tableStyles = useTableStyles();
  const dayCellStyles = useDayCellStyles();
  const daySelectedStyles = useDaySelectedStyles();
  const weekRowStyles = useWeekRowStyles();
  const weekDayLabelCellStyles = useWeekDayLabelCellStyles();
  const weekNumberCellStyles = useWeekNumberCellStyles();
  const dayOutsideBoundsStyles = useDayOutsideBoundsStyles();
  const dayOutsideNavigatedMonthStyles = useDayOutsideNavigatedMonthStyles();
  const dayButtonStyles = useDayButtonStyles();
  const dayIsTodayStyles = useDayIsTodayStyles();
  const firstTransitionWeekStyles = useFirstTransitionWeekStyles();
  const lastTransitionWeekStyles = useLastTransitionWeekStyles();
  const dayMarkerStyles = useDayMarkerStyles();
  const cornerBorderAndRadiusStyles = useCornerBorderAndRadiusStyles();
  const {
    animateBackwards,
    animationDirection,
    lightenDaysOutsideNavigatedMonth,
    showWeekNumbers
  } = props;
  return {
    wrapper: mergeClasses(calendarDayGridClassNames.wrapper, wrapperStyles.base),
    table: mergeClasses(calendarDayGridClassNames.table, tableStyles.base, showWeekNumbers && tableStyles.showWeekNumbers),
    dayCell: mergeClasses(calendarDayGridClassNames.dayCell, dayCellStyles.base, cornerBorderAndRadiusStyles.corners),
    daySelected: mergeClasses(calendarDayGridClassNames.daySelected, daySelectedStyles.base),
    weekRow: mergeClasses(calendarDayGridClassNames.weekRow, animateBackwards !== undefined && weekRowStyles.base, animateBackwards !== undefined && (animationDirection === AnimationDirection.Horizontal ? animateBackwards ? weekRowStyles.horizontalBackward : weekRowStyles.horizontalForward : animateBackwards ? weekRowStyles.verticalBackward : weekRowStyles.verticalForward)),
    weekDayLabelCell: mergeClasses(calendarDayGridClassNames.weekDayLabelCell, weekDayLabelCellStyles.base),
    weekNumberCell: mergeClasses(calendarDayGridClassNames.weekNumberCell, weekNumberCellStyles.base),
    dayOutsideBounds: mergeClasses(calendarDayGridClassNames.dayOutsideBounds, dayOutsideBoundsStyles.base),
    dayOutsideNavigatedMonth: mergeClasses(calendarDayGridClassNames.dayOutsideNavigatedMonth, lightenDaysOutsideNavigatedMonth && dayOutsideNavigatedMonthStyles.lightenDaysOutsideNavigatedMonth),
    dayButton: mergeClasses(calendarDayGridClassNames.dayButton, dayButtonStyles.base),
    dayIsToday: mergeClasses(calendarDayGridClassNames.dayIsToday, dayIsTodayStyles.base),
    firstTransitionWeek: mergeClasses(calendarDayGridClassNames.firstTransitionWeek, firstTransitionWeekStyles.base, animateBackwards !== undefined && animationDirection !== AnimationDirection.Horizontal && !animateBackwards && firstTransitionWeekStyles.verticalForward),
    lastTransitionWeek: mergeClasses(calendarDayGridClassNames.lastTransitionWeek, lastTransitionWeekStyles.base, animateBackwards !== undefined && animationDirection !== AnimationDirection.Horizontal && animateBackwards && lastTransitionWeekStyles.verticalBackward),
    dayMarker: mergeClasses(calendarDayGridClassNames.dayMarker, dayMarkerStyles.base)
  };
};
//# sourceMappingURL=useCalendarDayGridStyles.styles.js.map